
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPropsResult } from 'next';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { toast } from 'sonner';
import { useLocalStorage } from 'react-use';
import { Product } from 'types';
import { getOneTimeProductsWithPrices } from '@/data/products';
import CallToAction from '@/components/CallToAction';
import Features2 from '@/components/Features2';
import HeroSection from '@/components/HeroSection';
import Footer from '@/components/layout/Footer';
import LogosCloud from '@/components/LogosCloud';
import MainFeatures from '@/components/MainFeatures';
import Seo from '@/components/Seo';
import Testimonials from '@/components/Testimonials';
import { useSpecialOffer } from '@/utils/useSpecialOffer';
/**
 * SVGR Support
 * Caveat: No React Props Type.
 *
 * You can override the next-env if the type is important to you
 * @see https://stackoverflow.com/questions/68103844/how-to-override-next-js-svg-module-declaration
 */
interface Props {
    products: Product[];
}
export default function HomePage({ products }: Props) {
    const router = useRouter();
    const { isSpecialOffer } = useSpecialOffer();
    const { from } = router.query;
    const [fromValue] = useLocalStorage('from', from);
    return (<main>
      {/* <Banner /> */}
      <Seo templateTitle={isSpecialOffer
            ? 'Promo code to get 30% off in 2024'
            : 'Affordable AI Writer'} description='Easy-Peasy.AI will save you time and help you produce polished content quickly and easily.' image='https://easy-peasy.ai/images/og-home.jpeg'/>
      <HeroSection />
      <LogosCloud />

      <MainFeatures />
      <Features2 />

      {/* <Features /> */}
      {/* <Banner /> */}

      {/* <SpecialOfferPricing products={products} /> */}

      <Testimonials />
      {/* <SpecialOfferFaq /> */}
      <CallToAction />
      <Footer />
    </main>);
}
async function getStaticProps(): Promise<GetStaticPropsResult<Props>> {
    const products = await getOneTimeProductsWithPrices();
    return {
        props: {
            products,
        },
        revalidate: 60,
    };
}

    async function __Next_Translate__getStaticProps__1a11b03d361__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/special-offer',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a11b03d361__ as getStaticProps }
  